"use client";
import { IBlocks, IForm, IUserData } from "@/types";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
import { cn } from "@/lib/utils";
import { Label } from "@/components/ui/label";
import moment from "moment";
import { Input } from "@/components/ui/input";
import { IconLoader2 } from "@tabler/icons-react";
import { Skeleton } from "@/components/ui/skeleton";
interface Props {
    account: IUserData;
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}

export default function FormOptions({
    account,
    block,
    blockUpdate,
    update,
}: Props) {
    const [forms, setForms] = React.useState<IForm[]>([]);
    const [loading, setLoading] = React.useState(false);
    const [oldBlock, setOldBlock] = React.useState(block);
    const [name, setName] = React.useState(block.name);
    React.useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(
                    `/api/account/${account.id}/form/list`,
                    { cache: "no-store" }
                );
                const data = await response.json();
                setForms(data.forms);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching data:", error);
                setForms([]);
            }
        };
        fetchData();
    }, [account]);
    const select = (form_id: string) => {
        update({
            ...block,
            options: {
                ...block.options,
                form_id: form_id,
            },
        });
    };
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting title={""} noBorder>
                <Input
                    label="Title"
                    description="Leave blank to use the form name"
                    placeholder="My Form"
                    variant="card"
                    className="w-full"
                    parentClassName="mb-4"
                    required
                    value={name}
                    onChange={(e) => {
                        setName(e.target.value);
                        blockUpdate({
                            ...block,
                            name: e.target.value,
                        });
                    }}
                    onBlur={(e) => {
                        if (oldBlock.name != e.target.value) {
                            update({
                                ...block,
                                name: e.target.value,
                            });
                            setOldBlock({
                                ...oldBlock,
                                name: e.target.value,
                            });
                        }
                    }}
                />
                {loading ? (
                    <div className="relative flex w-full flex-col gap-2">
                        <Label variant={"toggle"}>
                            Loading forms{" "}
                            <IconLoader2 size={16} className="animate-spin" />
                        </Label>
                        <Skeleton className="h-16 w-full bg-accent" />
                        <Skeleton className="h-16 w-full bg-accent" />
                        <Skeleton className="h-16 w-full bg-accent" />
                    </div>
                ) : (
                    <div className="relative flex w-full flex-col gap-2">
                        <Label variant={"toggle"}>Select a form</Label>
                        {forms.length === 0 ? (
                            <div className="">
                                <Label variant={"toggle"}>
                                    You don't have any forms yet.
                                </Label>
                                <Label variant={"subtoggle"}>
                                    Create a form first.
                                </Label>
                            </div>
                        ) : (
                            forms.map((form, index) => {
                                return (
                                    <div
                                        key={index}
                                        onClick={() => {
                                            if (
                                                form.id !==
                                                block.options?.form_id
                                            ) {
                                                select(form.id);
                                            }
                                        }}
                                        className={cn(
                                            "flex items-start gap-2 rounded-md border-2 p-2",
                                            form.id === block.options?.form_id
                                                ? "border-primary"
                                                : ""
                                        )}
                                    >
                                        <div className="flex flex-col">
                                            <Label
                                                variant="toggle"
                                                className="text-lg"
                                            >
                                                {form.name}
                                            </Label>
                                            <Label variant={"subtoggle"}>
                                                Created{" "}
                                                {moment(form.created_at).format(
                                                    "Do MMM, YYYY"
                                                )}{" "}
                                                (
                                                {moment(
                                                    form.created_at
                                                ).fromNow()}
                                                )
                                            </Label>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                )}
            </CardSetting>
        </div>
    );
}
